const style = {
    display: "inline-block",
    height: "1em",
};

const props = {
    style,
    fill: "currentColor",
    "aria-hidden": true,
    focusable: false,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
};

// d6
export const DiceRoller = (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M384 32H64C28.62 32 0 60.62 0 96v320c0 35.38 28.62 64 64 64h320c35.38 0 64-28.62 64-64V96C448 60.62 419.4 32 384 32zM128 384c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S145.6 384 128 384zM128 288C110.4 288 96 273.6 96 256s14.38-32 32-32s32 14.38 32 32S145.6 288 128 288zM128 192C110.4 192 96 177.6 96 160s14.38-32 32-32s32 14.38 32 32S145.6 192 128 192zM320 384c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S337.6 384 320 384zM320 288c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S337.6 288 320 288zM320 192c-17.62 0-32-14.38-32-32s14.38-32 32-32s32 14.38 32 32S337.6 192 320 192z" />
    </svg>
);

// heart
export const HealthTracker = (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84.02L256 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 .0003 232.4 .0003 190.9L0 190.9z" />
    </svg>
);

export const WillpowerTracker = (
    <svg viewBox="0 0 512 512" {...props}>
        <path d="M509.2 275c-21-47.13-48.5-151.8-73.12-186.8C397.1 32.88 333.7 0 266.1 0L192 0C86 0 0 86 0 192c0 54.5 23.25 106.5 64 142.9L64 512h256l-.0052-64h63.99c35.38 0 63.1-28.62 63.1-63.1V320h31.1c10.88 0 20.89-5.5 26.77-14.62C512.8 296.4 513.6 284.9 509.2 275zM330.4 198.3L247.4 283.9c-5.387 5.504-13.95 5.504-19.34 0L145.1 198.3c-24.11-25.02-22.64-66.17 4.285-89.19c23.5-20.02 58.39-16.39 79.81 5.754l8.445 8.754L246 114.9c21.55-22.14 56.56-25.77 79.93-5.754C353 132.1 354.5 173.3 330.4 198.3z" />
    </svg>
);
